<template>

<div id="main">
</div>

  <router-view/>
</template>

<style>



</style>
